import firebase from 'firebase';
import { FirebaseOptions } from '@firebase/app-types';

import config from '@/Constants';

const firebaseConfig: FirebaseOptions = config.FIREBASE_CONFIG;
const app = firebase.initializeApp(firebaseConfig);

export default app;
